import { createFileRoute } from "@tanstack/react-router";

import { sdk } from "@/api/sdk";
import { ClosingBand } from "@/features/portal/components/closing-band";
import { PortalHead, PortalPage } from "@/features/portal/components/portal-chrome";
import { CoachDirectory } from "@/features/portal/modules/coaches/coach-directory";
import { DIRECTORY_DAYS } from "@/features/portal/modules/coaches/directory-days";
import { HowHero, HowSteps } from "@/features/portal/modules/how-page/how-page";
import { pageMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/how-it-works/")({
  head: () => ({ meta: pageMeta({ title: m.portal_nav_how(), description: m.seo_how_description() }) }),
  // The page ends on the people who can be booked right now; a directory that cannot be reached
  // leaves that section out rather than failing the route.
  loader: async () => {
    const { data } = await sdk.t.bookable.$get.setQueryParams({ days: String(DIRECTORY_DAYS) }).send();
    return { crumb: m.portal_nav_how(), trainers: data ?? [] };
  },
  component: HowItWorksPage,
});

/**
 * The way in, stop by stop: find a coach, book, get reminded, train, and grow with the coach
 * watching, then the coaches who can be booked this week.
 */
function HowItWorksPage() {
  const { trainers } = Route.useLoaderData();

  return (
    <PortalPage
      head={
        <PortalHead>
          <HowHero />
        </PortalHead>
      }
    >
      <HowSteps />
      <CoachDirectory trainers={trainers} />
      <ClosingBand />
    </PortalPage>
  );
}
